<footer class="container">
    <p class="float-end"><a href="#">Back to top</a></p>
    <p>&copy; 2021 Spell Estética &middot; <a href="#">Privacy</a> &middot; <a href="#">Terms</a></p>
  </footer>